module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmh1"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_als_r1"
    }
  }, [_vm._v("Also by Adam Clay")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_tp_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_ded_r1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_ack_r1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_fm1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scientific Method")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c01_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I - You exist only in the delirious illusion of language.")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c01_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Natural History")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c01_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I’m Pretty Sure That’s a Hurdle in the Distance")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c01_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sonnet")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c01_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slow Dancing Around What I Really Have to Say")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c01_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fragment for an Avoided Disaster")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c01_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poem Beginning with a Line from Tranströmer")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c01_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Bread Crust")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c01_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Self-Portrait with House Slippers and Tap Water")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c01_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Horse")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c01_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On the Momentum of Memory")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c01_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Your Eyelash Anchored to the Sky")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c01_r1#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poem in Place of a Fractured Sonnet")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c01_r1#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Song")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c02_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harbor")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c02_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("As Complete as a Thought Can Be")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III - Complaint’s a sort of orchard.")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c03_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recalling an Earlier Snow During a Present Storm")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c03_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thought For a Stalled World")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c03_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Memory, Forgotten at the End of a Season")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c03_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For the Driftwood I Once Loved")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c03_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Myth Left in Memory")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c03_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Thought Before Thought")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c03_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For the Earnest Days Before Summer")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c03_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vine")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c03_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Movement Sounds Like")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c03_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Day in August")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c03_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gathered")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c03_r1#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Goodbye to All That, the Birds Included")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV - Let us all be from somewhere. Let us tell each other everything we can.")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c04_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elegy for a Thousand Half-Masts")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c04_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Light Bulb Hum")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c04_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Light of Recent Developments")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c04_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maybe Motion Will Save Us All")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c04_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Moment of Waking")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c04_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reaching for a Lexicon, an Apple No Longer Shining")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c04_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Stop Migration")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_c04_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Hotel Lobby at the Edge of the World")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_bm1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Poetry from Milkweed Editions")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/adam_9781571318602_oeb_cop_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96a08c00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/adam_9781571318602_oeb_toc_r1.vue
// module id = 63
// module chunks = 0